var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGatepass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.94444C1 3.48985 2.98985 1.5 5.44444 1.5H16.5556C19.0102 1.5 21 3.48985 21 5.94444C21 6.48773 20.6884 6.98288 20.1986 7.21798L19.7113 7.45192C17.993 8.2767 17.993 10.7233 19.7113 11.5481L20.1986 11.782C20.6884 12.0171 21 12.5123 21 13.0556C21 15.5102 19.0102 17.5 16.5556 17.5H5.44444C2.98985 17.5 1 15.5102 1 13.0556C1 12.5123 1.31157 12.0171 1.80135 11.782L2.28872 11.5481C4.00702 10.7233 4.00702 8.2767 2.28872 7.45192L1.80135 7.21798C1.31157 6.98288 1 6.48773 1 5.94444Z",
    stroke: "#00205E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0175 7.23737C10.3268 6.25421 11.6732 6.25421 11.9825 7.23737C12.1208 7.67705 12.5174 7.97473 12.965 7.97473C13.9657 7.97473 14.3818 9.29756 13.5722 9.90519C13.2101 10.1769 13.0586 10.6586 13.1969 11.0983C13.5062 12.0814 12.4168 12.899 11.6072 12.2914C11.2451 12.0196 10.7549 12.0196 10.3928 12.2914C9.58318 12.899 8.49385 12.0814 8.80309 11.0983C8.94139 10.6586 8.78989 10.1769 8.42782 9.90519C7.6182 9.29756 8.03429 7.97473 9.03503 7.97473C9.48257 7.97473 9.87921 7.67705 10.0175 7.23737Z",
    stroke: "#00205E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatepass);
export default __webpack_public_path__ + "static/media/gatepass.15073a776d68a6a72c019e3cd9eb7f2a.svg";
export { ForwardRef as ReactComponent };